module.exports = __webpack_public_path__ + "img/generated-1772421180139.a56db713.png";